import { CommonMessages } from '../common.messages';

/**
 * Every `*Failed` message below is a tail, not a whole sentence: the screen joins it to a cause
 * taken from the status (CouponBondFailureMessage in the descriptor), so the operator is told both
 * what failed and why. They used to open with "Error while communication with the server", which
 * was asserted for every status the screen did not map and sent FP-1752 after the network for an
 * afternoon while the server had been answering 409 all along.
 */
export const PanelCouponBondsMessages = {
    GetCouponBondPaymentFailed: {
        key: 'GetCouponBondPaymentFailed',
        message: 'Unable to get the coupon payment.'
    },
    /**
     * 204 from the distribution-list read. The payment exists but its observation cut-off has not
     * passed, or generation has not run yet - an upcoming coupon, not a failure.
     */
    CouponBondPaymentNotGenerated: {
        key: 'CouponBondPaymentNotGenerated',
        message: 'This coupon payment has no distribution list yet.'
    },
    SetReceiptSuccess: {
        key: 'SetReceiptSuccess',
        message: 'Receipt saved.'
    },
    /** Saving after a calculation drops the allocation, so the operator is told rather than left to notice. */
    SetReceiptInvalidated: {
        key: 'SetReceiptInvalidated',
        message: 'Received Amount changed — the allocation was invalidated. Recalculate to continue.'
    },
    CalculateSuccess: {
        key: 'CalculateSuccess',
        message: 'Distribution calculated. Review the allocation before distributing.'
    },
    CalculateFailed: {
        key: 'CalculateFailed',
        message: 'Unable to calculate the distribution.'
    },
    /** 409: a row has posted, so the allocation is what real money was moved against. */
    CalculateRejected: {
        key: 'CalculateRejected',
        message: 'This coupon payment can no longer be calculated.'
    },
    RetryGenerationSuccess: {
        key: 'RetryGenerationSuccess',
        message: 'Generation ran again. The attempt history below records the outcome.'
    },
    RetryGenerationFailed: {
        key: 'RetryGenerationFailed',
        message: 'Unable to retry the generation.'
    },
    /** 409: generation did not fail for this payment, so there is nothing to retry. */
    RetryGenerationRejected: {
        key: 'RetryGenerationRejected',
        message: 'Generation cannot be retried for this coupon payment.'
    },
    /** 423: the generation lock is held, so nothing ran and the attempt history is unchanged. */
    RetryGenerationLocked: {
        key: 'RetryGenerationLocked',
        message: 'Generation did not start because another attempt is already running — try again shortly.'
    },
    SetReceiptFailed: {
        key: 'SetReceiptFailed',
        message: 'Unable to save the receipt.'
    },
    /**
     * 409 from the receipt endpoint: the payment moved on between loading the page and saving -
     * once a distribution has started the amount its postings were derived from is fixed.
     */
    SetReceiptRejected: {
        key: 'SetReceiptRejected',
        message: 'The receipt can no longer be changed for this coupon payment.'
    },
    RetryFailedSuccess: {
        key: 'RetryFailedSuccess',
        message: 'Failed postings re-armed. They are re-posted by the posting job.'
    },
    RetryFailedFailed: {
        key: 'RetryFailedFailed',
        message: 'Unable to retry the failed postings.'
    },
    /** 409: the payment is not in a state where postings can be re-armed. */
    RetryFailedRejected: {
        key: 'RetryFailedRejected',
        message: 'Failed postings cannot be retried for this coupon payment.'
    },
    DistributeSuccess: {
        key: 'DistributeSuccess',
        message: 'Distribution started. The postings are created by the posting job.'
    },
    DistributeFailed: {
        key: 'DistributeFailed',
        message: 'Unable to start the distribution.'
    },
    /**
     * 409: the payment is not Ready for Distribution, or a pre-distribution revalidation refused
     * it because an order behind a claim had been rejected. That case is resolved outside this
     * module and there is no override here.
     */
    DistributeRejected: {
        key: 'DistributeRejected',
        message: 'This coupon payment cannot be distributed in its current state.'
    },
    /** The queue export, which is a different file from the distribution list's. */
    ExportQueueFailed: {
        key: 'ExportQueueFailed',
        message: 'Unable to export the queue.'
    },
    ExportFailed: {
        key: 'ExportFailed',
        message: 'Unable to export the distribution list.'
    },
    ...CommonMessages
};
